import React, { useState, useEffect } from "react";
import { Box, TextField } from "@mui/material";
import "../styles/timeline.css";
import { Timeline as AntTimeline } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";

const Timeline = () => {
  // const [activities, setActivities] = useState([]);
  const [data, setData] = useState([]);
  const [editTimelineId, setEditTimelineId] = useState(null);
  const { contactId } = useParams();
  // console.log(contactId);
  const [timeline, setTimeline] = useState({
    title: "",
    description: "",
  });

  const fetchTimelineData = async () => {
    try {
      const response = await axios.get(
        `/api/timeline/${contactId}/gettimeline`
      );
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTimelineData();
  }, [contactId]);

  // console.log(data);

  const handleChangeTimeline = (e) => {
    const { name, value } = e.target;
    setTimeline({
      ...timeline,
      [name]: value,
    });
  };

  // const handleSave = () => {
  //   if (title.trim() !== "") {
  //     // Only add non-empty titles to the timeline
  //     setActivities((prevActivities) => [...prevActivities, title]);
  //     setTitle("");
  //   }
  // };

  const handleEditTimeline = (_id) => {
    const selectedTimeline = data.find((timelineid) => timelineid._id === _id);

    if (selectedTimeline) {
      setEditTimelineId(_id); // Set the ID of the contact being edited
      setTimeline({
        title: selectedTimeline.title,
        description: selectedTimeline.description,
      });
    }
  };

  const handleDeleteTimeline = async (_id) => {
    // Show SweetAlert2 confirm dialog
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      // Show a loading spinner while holding the action
      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      }); ///api/timeline/:id/deletetimeline/:id
      axios
        .delete(`/api/timeline/${contactId}/deletetimeline/${_id}`)
        .then((res) => {
          fetchTimelineData();
          Swal.fire("Deleted!", "Timeline deleted successfully!", "success");
        })
        .catch((error) => {
          Swal.fire("Error", "Something went wrong!", "error");
        });
    }
  };

  const handleAddTimelineButton = () => {
    setEditTimelineId(null);
    setTimeline({ title: "", description: "" });
  };

  const handleSave = (e) => {
    e.preventDefault();

    const timelineData = {
      ...timeline,
    };

    if (editTimelineId) {
      axios
        .put(
          `/api/timeline/${contactId}/updatetimeline/${editTimelineId}`,
          timelineData
        )
        .then((res) => {
          setTimeline({ title: "", description: "" });
          Swal.fire({
            title: "Timeline Updated successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchTimelineData();
          });
        })
        .catch((error) => {
          console.error("Error creating Timeline:", error);
          Swal.fire(
            "Error",
            "Error creating Timeline. Please try again.",
            "error"
          );
        });
    } else {
      axios
        .post(`/api/timeline/${contactId}/create`, timelineData)
        .then((res) => {
          setTimeline({ title: "", description: "" });
          Swal.fire({
            title: "Timeline Added successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchTimelineData();
          });
        })
        .catch((error) => {
          console.error("Error creating Timeline:", error);
          Swal.fire(
            "Error",
            "Error creating Timeline. Please try again.",
            "error"
          );
        });
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p></p>
        <button
          type="button"
          className="btn btn-primary add-btn"
          onClick={handleAddTimelineButton}
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        >
          <i className="ri-add-fill me-1 align-bottom"></i> New Activity
        </button>
        {/* <!-- Modal --> */}
        <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {editTimelineId ? "Update New Activity" : "New Activity"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <Box>
                  <TextField
                    autoFocus
                    color="primary"
                    fullWidth
                    label="Title"
                    name="title"
                    value={timeline.title}
                    onChange={handleChangeTimeline}
                    margin="normal"
                    required
                  />
                  <TextField
                    autoFocus
                    color="primary"
                    fullWidth
                    label="Description"
                    name="description"
                    value={timeline.description}
                    onChange={handleChangeTimeline}
                    margin="normal"
                    required
                  />
                </Box>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                  data-bs-dismiss="modal"
                >
                  {editTimelineId ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="timeline-tracking">
        <div className="timeline-tracking">
          <AntTimeline>
            {activities.map((activity, index) => (
              <AntTimeline.Item key={index}>
                <div className="timeline-title">{activity}</div>
              </AntTimeline.Item>
            ))}
          </AntTimeline>
        </div>
      </div> */}
      <div className="timeline-tracking">
        <AntTimeline>
          {data.map((timelineItem) => (
            <AntTimeline.Item key={timelineItem.id}>
              <div className="timeline-title">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="timeline_heading">
                    <h6>{timelineItem.title} </h6>
                  </div>
                  <div>
                    <span>
                      {new Date(timelineItem.createdOn).toLocaleString()}
                    </span>
                  </div>
                </div>
                <span>{timelineItem.description}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <div style={{ display: "flex", gap: "10px", fontSize: "18px" }}>
                  <div>
                    <button
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => handleEditTimeline(timelineItem._id)}
                      className="timeline-edit-btn"
                    >
                      <i className="ri-pencil-fill"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={() => handleDeleteTimeline(timelineItem._id)}
                      className="timeline-delete-btn"
                    >
                      <i className="ri-delete-bin-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </AntTimeline.Item>
          ))}
        </AntTimeline>
      </div>
    </>
  );
};

export default Timeline;
